import { useAuthStore } from '@/stores/auth.store'

export default defineNuxtRouteMiddleware(async (to, from) => {
  const runtimeConfig = useRuntimeConfig()
  const api = runtimeConfig.public.api

  if (process.client) {
    const authStore = useAuthStore()

    //  Paths sem autenticacao
    // ------------------------
    if (to.path.match(/^admin/gi) && authStore.isAdmin === false) { // Login não precisa de autenticação, todo o resto vai precisar
      return navigateTo('/login')
    }
  }
})
